import { number, oneOf, shape, string } from 'prop-types'
import { TemperatureSensorTypes } from '../../models/cold-chain/temperature-sensor-types-enum'
import { EventLevels } from '../../models/notifications/event-levels-enum'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
/**
 * @typedef {Object} TemperatureSensorConfig
 * @property {string} sensorConfigId
 * @property {string} sensorCode
 * @property {string} name
 * @property {string} objectId
 * @property {string} type
 * @property {number} [lowerThreshold]
 * @property {number} [upperThreshold]
 * @property {number} [sortIndex]
 * @property {number} [sortIndex]
 * @property {string} [notificationLevel]
 * @property {iso8601DurationPropType} [notificationDelay]
 */

export const temperatureSensorConfigPropType = shape({
    sensorConfigId: string.isRequired,
    sensorCode: string.isRequired,
    name: string.isRequired,
    objectId: string.isRequired,
    type: oneOf(Object.values(TemperatureSensorTypes)).isRequired,
    lowerThreshold: number,
    upperThreshold: number,
    sortIndex: number,
    notificationLevel: oneOf(Object.values(EventLevels)),
    notificationDelay: iso8601DurationPropType
})
